<template>
  <div class="page-delivered">
    <div class="pg-breadcrumb">
      <div class="breadcrumb-item em">客服專區</div>
      <div class="breadcrumb-item">已簽收(全部)</div>
    </div>

    <div class="card-block">
      <Form inline class="pg-form-inline">
        <FormItem>
          <Select
            size="small"
            clearable
            placeholder="提貨櫃點"
            v-model="form.arrive"
          >
            <Option
              :value="item.ReceivingID"
              v-for="(item, index) in pickAddress"
              :key="item.ReceivingID"
              >({{ item.cainiao_match }}) {{ item.ReceivingName }}
            </Option>
          </Select>
        </FormItem>

        <FormItem>
          <Select
            size="small"
            clearable
            placeholder="收件方式"
            v-model="form.arrive_type"
          >
            <Option value="1">門店</Option>
            <Option value="2">智能櫃</Option>
          </Select>
        </FormItem>
        <FormItem>
          <Select
            size="small"
            clearable
            placeholder="操作人"
            v-model="form.admin_id"
          >
            <Option
              :value="item.user_id"
              v-for="(item, index) in pickAdmin"
              :key="item.user_id"
              >{{ item.username }} ({{ item.realname }})
            </Option>
          </Select>
        </FormItem>
        <FormItem>
          <DatePicker
            class="no-suffix"
            type="datetime"
            size="small"
            :clearable="false"
            placeholder="起始日期"
            v-model="form.start_time"
            value-format="yyyy-MM-dd hh:mm:ss"
            :editable="false"
            style="width: 100%"
          ></DatePicker>
        </FormItem>
        <FormItem>-</FormItem>
        <FormItem>
          <DatePicker
            class="no-suffix"
            type="datetime"
            size="small"
            :clearable="false"
            placeholder="結束日期"
            v-model="form.end_time"
            value-format="yyyy-MM-dd hh:mm:ss"
            :editable="false"
            style="width: 100%"
          ></DatePicker>
        </FormItem>
      </Form>

      <Form inline class="pg-form-inline form-input-wrap">
        <FormItem>
          <label class="input-label">快遞單號</label>
          <Input
            size="small"
            clearable
            v-model="form.odd_numbers"
            @keyup.enter.native="handleSearch()"
          ></Input>
        </FormItem>
        <FormItem>
          <label class="input-label">客戶名稱</label>
          <Input
            size="small"
            clearable
            v-model="form.recipient_contacts"
            @keyup.enter.native="handleSearch()"
          ></Input>
        </FormItem>
        <FormItem>
          <label class="input-label">手機號碼</label>
          <Input
            size="small"
            clearable
            v-model="form.phone"
            @keyup.enter.native="handleSearch()"
          ></Input>
        </FormItem>
        <FormItem>
          <label class="input-label">袋號</label>
          <Input
            size="small"
            clearable
            v-model="form.sack_number"
            @keyup.enter.native="handleSearch()"
          ></Input>
        </FormItem>
        <FormItem>
          <div class="pg-btn-wrap">
            <div class="pg-btn style1" @click="handleSearch">搜索</div>
          </div>
        </FormItem>
      </Form>
    </div>

    <div class="card-block pd-bt">
      <Spin fix class="pg-sub-loading" v-if="isSubmiting">
        <Icon type="ios-loading" :size="20" class="demo-spin-icon-load"></Icon>
        <div class="loading-text">Loading</div>
      </Spin>
      <Table
        size="small"
        border
        no-data-text="暫無數據"
        :columns="table.column"
        :data="table.data"
      >
        <template slot-scope="{ row, index }" slot="arrive_type">
          <!-- 取貨方式 1:門店取貨; 2:智能櫃取貨-->
          <span v-if="row.arrive_type == 1">門店取貨</span>
          <span v-else-if="row.arrive_type == 2">智能櫃取貨</span>
        </template>

        <template slot-scope="{ row, index }" slot="status">
          <!-- 货物状态 0:待出库;1:已出库;2:配送中;3:代取件;4:已签收 -->
          <span v-if="row.status == 0">待出庫</span>
          <span v-else-if="row.status == 1">已出庫</span>
          <span v-else-if="row.status == 2">配送中</span>
          <span v-else-if="row.status == 3">待取件</span>
          <span v-else-if="row.status == 4">已簽收</span>
        </template>

        <template slot-scope="{ row, index }" slot="action">
          <div class="pg-btn-wrap">
            <!-- <div class="pg-btn style1" @click="handleEdit(index)" v-if="account_permission == 1">修改</div> -->
            <div class="pg-btn style3" @click="handleViewWuliu(index)">
              物流
            </div>
            <div
              class="pg-btn style2"
              @click="handleViewRemark(index)"
              v-if="account_permission == 1"
            >
              備註
            </div>
          </div>
        </template>
      </Table>

      <div class="pg-pagger">
        <Row>
          <Col span="12" class="pagger-left">
            <div class="pagger-total">總共{{ totalCount }}條記錄</div>
          </Col>
          <Col span="12" class="pagger-right">
            <!-- v-if="totalCount > curPageSize" -->
            <div>
              <div class="pagger-sizer">
                <span>每頁</span>
                <Select
                  v-model="curPageSize"
                  size="small"
                  placeholder="數量"
                  @on-change="handlePageSizeChange"
                >
                  <Option :value="10">10</Option>
                  <Option :value="20">20</Option>
                  <Option :value="30">30</Option>
                  <Option :value="40">40</Option>
                  <Option :value="50">50</Option>
                </Select>
              </div>

              <div class="pagger-elevator">
                <span>跳轉</span>
                <Input
                  size="small"
                  v-model="pageInput"
                  @on-keyup="handlePageInput"
                  @on-enter="handlePageEnter"
                />
              </div>

              <Page
                size="small"
                :current="pageIndex"
                :page-size="curPageSize"
                :total="totalCount"
                @on-change="handlePageChange"
              >
              </Page>
            </div>
          </Col>
        </Row>
      </div>
    </div>
  </div>
</template>

<script>
import Store from "../../../assets/js/store.js";

export default {
  data() {
    return {
      pageIndex: 1,
      curPageSize: 10,
      totalCount: 1,
      pageInput: "",
      pickAdmin: [],
      pickAddress: [],
      packageType: [],
      account_permission: Store.fetch().type,
      isSubmiting: false,
      form: {
        arrive: "",
        arrive_type: "",
        goods_type: "",
        start_time: "",
        end_time: "",
        recipient_contacts: "",
        phone: "",
        odd_numbers: "",
        sack_number: "",
        admin_id: "",
      },
      table: {
        column: [
          {
            title: "操作",
            slot: "action",
            align: "center",
            minWidth: 150,
            fixed: "left",
          },
          {
            title: "新/舊",
            key: "order_type",
            align: "center",
            minWidth: 70,
          },
          {
            title: "一/二次支付",
            key: "order_online",
            align: "center",
            minWidth: 80,
          },
          {
            title: "客戶名稱",
            key: "recipient_contacts",
            align: "center",
            minWidth: 130,
            sortable: true,
          },
          {
            title: "客戶電話",
            key: "recipient_phone",
            align: "center",
            minWidth: 130,
            sortable: true,
          },
          {
            title: "操作人(珠海倉庫)",
            key: "admininfo_realname",
            align: "center",
            minWidth: 100,
            sortable: true,
          },
          {
            title: "袋號",
            key: "sack_number",
            align: "center",
            minWidth: 150,
            sortable: true,
          },
          {
            title: "出貨單號",
            key: "odd_numbers",
            align: "center",
            minWidth: 150,
            sortable: true,
          },
          {
            title: "數量",
            key: "count",
            align: "center",
            minWidth: 50,
            sortable: true,
          },
          {
            title: "重量",
            key: "weight",
            align: "center",
            minWidth: 70,
            sortable: true,
          },
          {
            title: "泡重",
            key: "volume_weight",
            align: "center",
            minWidth: 70,
            sortable: true,
          },
          {
            title: "收件方式",
            key: "arrive_type",
            align: "center",
            slot: "arrive_type",
            minWidth: 100,
            sortable: true,
          },
          {
            title: "提貨櫃點",
            key: "receivingName",
            align: "center",
            minWidth: 120,
            sortable: true,
          },
          {
            title: "貨物狀態",
            key: "status",
            align: "center",
            slot: "status",
            minWidth: 100,
            sortable: true,
          },
          {
            title: "貨架號",
            key: "shelves",
            align: "center",
            minWidth: 100,
            sortable: true,
          },
          {
            title: "珠海入庫時間",
            key: "in_time",
            align: "center",
            minWidth: 160,
            sortable: true,
          },
          {
            title: "珠海出庫日期",
            key: "out_time",
            align: "center",
            minWidth: 160,
            sortable: true,
          },
          {
            title: "澳門倉庫入庫日期",
            key: "macao_originating_time",
            align: "center",
            minWidth: 160,
            sortable: true,
          },
          {
            title: "澳門倉庫出庫日期",
            key: "macao_originating_out_time",
            align: "center",
            minWidth: 160,
            sortable: true,
          },
          {
            title: "澳門門店到達日期",
            key: "arrive_time",
            align: "center",
            minWidth: 160,
            sortable: true,
          },
          {
            title: "澳門門店簽收日期",
            key: "pick_time",
            align: "center",
            minWidth: 160,
            sortable: true,
          },
          {
            title: "代收費",
            key: "amount",
            align: "center",
            className: "demo-table-info-cell-name",
            minWidth: 50,
            sortable: true,
          },
          {
            title: "到付運費",
            key: "freight_collect",
            align: "center",
            className: "demo-table-info-cell-name",
            minWidth: 50,
            sortable: true,
          },
          {
            title: "加收附加費",
            key: "surcharge_price",
            align: "center",
            className: "demo-table-info-cell-name",
            minWidth: 50,
            sortable: true,
          },
          {
            title: "超期費",
            key: "outtimepay",
            align: "center",
            className: "demo-table-info-cell-name",
            minWidth: 50,
            sortable: true,
          },
          {
            title: "立減費",
            key: "activity",
            align: "center",
            className: "demo-table-info-cell-name",
            minWidth: 50,
            sortable: true,
          },
          {
            title: "合計費用",
            key: "sum",
            align: "center",
            className: "demo-table-info-cell-name",
            minWidth: 50,
            sortable: true,
          },
          {
            title: "會員積分(支付)",
            key: "credit",
            className: "demo-table-info-column",
            align: "center",
            minWidth: 50,
            sortable: true,
          },
          {
            title: "現金(支付)",
            key: "cash",
            align: "center",
            minWidth: 50,
            sortable: true,
            className: "demo-table-info-column",
          },
          {
            title: "澳門通(支付)",
            key: "macaupass",
            align: "center",
            minWidth: 50,
            sortable: true,
            className: "demo-table-info-column",
          },
          {
            title: "Mpay(支付)",
            key: "mpay",
            align: "center",
            minWidth: 50,
            sortable: true,
            className: "demo-table-info-column",
          },
          {
            title: "支付寶(支付)",
            key: "alipay",
            align: "center",
            minWidth: 50,
            sortable: true,
            className: "demo-table-info-column",
          },
          {
            title: "中銀POS(支付)",
            key: "zyPos",
            align: "center",
            minWidth: 50,
            sortable: true,
            className: "demo-table-info-column",
          },
          {
            title: "工商POS(支付)",
            key: "icbc",
            align: "center",
            minWidth: 50,
            sortable: true,
            className: "demo-table-info-column",
          },
          {
            title: "微信(支付)",
            key: "wxpay",
            align: "center",
            minWidth: 50,
            sortable: true,
            className: "demo-table-info-column",
          },
          {
            title: "備註",
            key: "remarks",
            align: "center",
            minWidth: 160,
            sortable: true,
          },
        ],
        data: [],
      },
    };
  },
  created() {
    this.getPickAddress();
    this.getPickAdmin();
  },
  mounted() {
    this.getList();
  },
  activated() {
    this.getPickAddress();
    this.getPickAdmin();
    this.getList();
  },
  methods: {
    handleViewWuliu(index) {
      let tableData = this.table.data;
      this.$router.push({
        path:
          "/shopSignedlogisticsInfo?orderNo=" + tableData[index].odd_numbers,
      });
    },
    handleViewRemark(index) {
      let tableData = this.table.data;
      this.$router.push({
        path: "/shopSignedRemark?id=" + tableData[index].id,
      });
    },
    handleDelete(index) {
      this.$Modal.confirm({
        title: "提示",
        content: "確定刪除嗎？",
        cancelText: "取消",
        okText: "確定",
        onOk: () => {
          let tableData = this.table.data;
          this.isSubmiting = true;

          this.$Rq
            .requestAuth({
              url: this.$Api.deliverDelete + "/" + tableData[index].id,
              method: "delete",
            })
            .then((res) => {
              this.isSubmiting = false;

              if (res.code == 0) {
                this.$Utils.showSuccess(res.msg);

                if (tableData.length <= 1 && this.pageIndex > 1) {
                  this.pageIndex -= 1;
                }

                this.getList();
              } else {
                this.$Utils.showTipInfo(res.msg);
              }
            })
            .catch((err) => {
              this.isSubmiting = false;
            });
        },
      });
    },

    //提貨櫃點
    getPickAddress() {
      this.$Rq
        .requestAuth({
          url: this.$Api.pickAddress,
          method: "get",
          data: {
            company_id: 0,
          },
        })
        .then((res) => {
          if (res.code == 0) {
            this.pickAddress = res.data.data.filter(
              (it) => it.company_id != 15
            );
          }
        });
    },
    //操作人
    getPickAdmin() {
      this.$Rq
        .requestAuth({
          url: this.$Api.pickAdmin,
          method: "post",
        })
        .then((res) => {
          if (res.code == 0) {
            this.pickAdmin = res.data.data;
          }
        });
    },
    formatDate(datetime) {
      if (!datetime) return "";

      let dateTime = new Date(datetime);
      let year = dateTime.getFullYear();
      let month = dateTime.getMonth() + 1;
      let date = dateTime.getDate();
      let hour = dateTime.getHours();
      let minute = dateTime.getMinutes();
      let second = dateTime.getSeconds();
      let milliseconds = dateTime.getMilliseconds();
      return `${this.formatNum(year)}-${this.formatNum(month)}-${this.formatNum(
        date
      )} ${this.formatNum(hour)}:${this.formatNum(second)}:${this.formatNum(
        milliseconds
      )}`;
    },
    formatNum(num) {
      return num < 10 ? "0" + num : num;
    },
    getList() {
      let form = this.form;
      this.isSubmiting = true;

      this.$Rq
        .requestAuth({
          url: this.$Api.scanIn,
          method: "get",
          data: {
            status: 4, //未签收3，已签收4
            offset: (this.pageIndex - 1) * this.curPageSize,
            limit: this.curPageSize,
            arrive: form.arrive,
            start_time: this.formatDate(form.start_time),
            end_time: this.formatDate(form.end_time),
            odd_numbers: form.odd_numbers,
            phone: form.phone,
            sack_number: form.sack_number,
            username: form.username,
            pay_type: form.pay_type,
          },
        })
        .then((res) => {
          this.isSubmiting = false;
          if (res.code == 0) {
            let tempArr = [];
            let class_pay_type = [];
            let resData = res.data.data;

            for (let i = 0; i < resData.length; i++) {
              let integral_tw = 0;
              let orderamount_additional_fee;
              let orderamount_credit;
              let orderamount_cash;
              let orderamount_alipay;
              let orderamount_macaupass;
              let orderamount_mpay;
              let orderamount_zyPos;
              let orderamount_icbc;
              let orderamount_wxpay;
              let orderamount_overtime_fee;
              let order_type;
              let order_online;

              const tws = resData[i].user?.tw?.length || 0;

              for (let j = 0; j < tws || 0; j++) {
                const iisa = resData[i].user?.tw[j]?.integral;
                let integral_tw_count = Number(iisa || 0);
                integral_tw += integral_tw_count;
              }

              if (resData[i].pay_status == 0) {
                resData[i].pay_status = "未付款";
              } else {
                resData[i].pay_status = "已付款";
              }

              if (resData[i].pay_type == 0) {
                class_pay_type[i] = "";
              } else {
                class_pay_type[i] = "demo-table-app-row";
              }

              if (resData[i].orderamount != null) {
                order_type = "新";

                if (
                  resData[i].orderamount.additional_fee == 0 ||
                  resData[i].orderamount.additional_fee == null
                ) {
                  orderamount_additional_fee = 0;
                } else {
                  orderamount_additional_fee =
                    resData[i].orderamount.additional_fee;
                }

                if (
                  resData[i].orderamount.overtime_fee == 0 ||
                  resData[i].orderamount.overtime_fee == null
                ) {
                  orderamount_overtime_fee = 0;
                } else {
                  orderamount_overtime_fee =
                    resData[i].orderamount.overtime_fee;
                }

                if (resData[i].orderamount.order_online == 1) {
                  //積分

                  order_online = "二次/積分";

                  if (resData[i].orderamount.credit == null) {
                    orderamount_credit = Number(
                      resData[i].orderamount.overtime_fee
                    );
                  } else {
                    orderamount_credit = Number(
                      resData[i].orderamount.overtime_fee +
                        resData[i].orderamount.credit +
                        resData[i].orderamount.credit_tw
                    );
                  }

                  if (resData[i].orderamount.cash > 0) {
                    orderamount_cash = Number(
                      resData[i].orderamount.cash +
                        resData[i].orderamount.overtime_fee
                    );
                  } else {
                    orderamount_cash = 0;
                  }

                  if (resData[i].orderamount.alipay > 0) {
                    orderamount_alipay = Number(
                      resData[i].orderamount.alipay +
                        resData[i].orderamount.overtime_fee
                    );
                  } else {
                    orderamount_alipay = 0;
                  }

                  if (resData[i].orderamount.macaupay > 0) {
                    orderamount_macaupass = Number(
                      resData[i].orderamount.macaupay +
                        resData[i].orderamount.overtime_fee
                    );
                  } else {
                    orderamount_macaupass = 0;
                  }

                  if (resData[i].orderamount.mpay > 0) {
                    orderamount_mpay = Number(
                      resData[i].orderamount.mpay +
                        resData[i].orderamount.overtime_fee
                    );
                  } else {
                    orderamount_mpay = 0;
                  }

                  if (resData[i].orderamount.boc > 0) {
                    orderamount_zyPos = Number(
                      resData[i].orderamount.boc +
                        resData[i].orderamount.overtime_fee
                    );
                  } else {
                    orderamount_zyPos = 0;
                  }

                  if (resData[i].orderamount.icbc > 0) {
                    orderamount_icbc = Number(
                      resData[i].orderamount.icbc +
                        resData[i].orderamount.overtime_fee
                    );
                  } else {
                    orderamount_icbc = 0;
                  }

                  if (resData[i].orderamount.wechat > 0) {
                    orderamount_wxpay = Number(
                      resData[i].orderamount.wechat +
                        resData[i].orderamount.overtime_fee
                    );
                  } else {
                    orderamount_wxpay = 0;
                  }
                }

                if (resData[i].orderamount.order_online == 2) {
                  //中銀

                  order_online = "二次/中銀";

                  if (resData[i].orderamount.boc == null) {
                    orderamount_zyPos = Number(
                      resData[i].orderamount.overtime_fee
                    );
                  } else {
                    orderamount_zyPos = Number(
                      resData[i].orderamount.overtime_fee +
                        resData[i].orderamount.boc
                    );
                  }

                  if (
                    Number(
                      resData[i].orderamount.credit +
                        resData[i].orderamount.credit_tw
                    ) > 0
                  ) {
                    orderamount_credit = Number(
                      resData[i].orderamount.credit +
                        resData[i].orderamount.credit_tw
                    );
                  } else {
                    orderamount_credit = 0;
                  }

                  if (resData[i].orderamount.cash > 0) {
                    orderamount_cash = Number(resData[i].orderamount.cash);
                  } else {
                    orderamount_cash = 0;
                  }

                  if (resData[i].orderamount.alipay > 0) {
                    orderamount_alipay = Number(resData[i].orderamount.alipay);
                  } else {
                    orderamount_alipay = 0;
                  }

                  if (resData[i].orderamount.macaupay > 0) {
                    orderamount_macaupass = Number(
                      resData[i].orderamount.macaupay
                    );
                  } else {
                    orderamount_macaupass = 0;
                  }

                  if (resData[i].orderamount.mpay > 0) {
                    orderamount_mpay = Number(resData[i].orderamount.mpay);
                  } else {
                    orderamount_mpay = 0;
                  }

                  if (resData[i].orderamount.icbc > 0) {
                    orderamount_icbc = Number(resData[i].orderamount.icbc);
                  } else {
                    orderamount_icbc = 0;
                  }

                  if (resData[i].orderamount.wechat > 0) {
                    orderamount_wxpay = Number(resData[i].orderamount.wechat);
                  } else {
                    orderamount_wxpay = 0;
                  }
                }

                if (resData[i].orderamount.order_online == 3) {
                  //工銀

                  order_online = "二次/工銀";

                  if (resData[i].orderamount.icbc == null) {
                    orderamount_icbc = Number(
                      resData[i].orderamount.overtime_fee
                    );
                  } else {
                    orderamount_icbc = Number(
                      resData[i].orderamount.overtime_fee +
                        resData[i].orderamount.icbc
                    );
                  }

                  if (
                    Number(
                      resData[i].orderamount.credit +
                        resData[i].orderamount.credit_tw
                    ) > 0
                  ) {
                    orderamount_credit =
                      Number(resData[i].orderamount.credit) +
                      Number(resData[i].orderamount.credit_tw);
                  } else {
                    orderamount_credit = 0;
                  }

                  if (resData[i].orderamount.cash > 0) {
                    orderamount_cash = Number(resData[i].orderamount.cash);
                  } else {
                    orderamount_cash = 0;
                  }

                  if (resData[i].orderamount.alipay > 0) {
                    orderamount_alipay = Number(resData[i].orderamount.alipay);
                  } else {
                    orderamount_alipay = 0;
                  }

                  if (resData[i].orderamount.macaupay > 0) {
                    orderamount_macaupass = Number(
                      resData[i].orderamount.macaupay
                    );
                  } else {
                    orderamount_macaupass = 0;
                  }

                  if (resData[i].orderamount.mpay > 0) {
                    orderamount_mpay = Number(resData[i].orderamount.mpay);
                  } else {
                    orderamount_mpay = 0;
                  }

                  if (resData[i].orderamount.boc > 0) {
                    orderamount_zyPos = Number(resData[i].orderamount.boc);
                  } else {
                    orderamount_zyPos = 0;
                  }

                  if (resData[i].orderamount.wechat > 0) {
                    orderamount_wxpay = Number(resData[i].orderamount.wechat);
                  } else {
                    orderamount_wxpay = 0;
                  }
                }

                if (resData[i].orderamount.order_online == 4) {
                  //微信

                  order_online = "二次/微信";

                  if (resData[i].orderamount.wechat == null) {
                    orderamount_wxpay = Number(
                      resData[i].orderamount.overtime_fee
                    );
                  } else {
                    orderamount_wxpay = Number(
                      resData[i].orderamount.overtime_fee +
                        resData[i].orderamount.wechat
                    );
                  }

                  if (
                    Number(
                      resData[i].orderamount.credit +
                        resData[i].orderamount.credit_tw
                    ) > 0
                  ) {
                    orderamount_credit =
                      Number(resData[i].orderamount.credit) +
                      Number(resData[i].orderamount.credit_tw);
                  } else {
                    orderamount_credit = 0;
                  }

                  if (resData[i].orderamount.cash > 0) {
                    orderamount_cash = Number(resData[i].orderamount.cash);
                  } else {
                    orderamount_cash = 0;
                  }

                  if (resData[i].orderamount.alipay > 0) {
                    orderamount_alipay = Number(resData[i].orderamount.alipay);
                  } else {
                    orderamount_alipay = 0;
                  }

                  if (resData[i].orderamount.macaupay > 0) {
                    orderamount_macaupass = Number(
                      resData[i].orderamount.macaupay
                    );
                  } else {
                    orderamount_macaupass = 0;
                  }

                  if (resData[i].orderamount.mpay > 0) {
                    orderamount_mpay = Number(resData[i].orderamount.mpay);
                  } else {
                    orderamount_mpay = 0;
                  }

                  if (resData[i].orderamount.boc > 0) {
                    orderamount_zyPos = Number(resData[i].orderamount.boc);
                  } else {
                    orderamount_zyPos = 0;
                  }

                  if (resData[i].orderamount.icbc > 0) {
                    orderamount_icbc = Number(resData[i].orderamount.icbc);
                  } else {
                    orderamount_icbc = 0;
                  }
                }

                if (resData[i].orderamount.order_online == 5) {
                  //Mpay

                  order_online = "二次/Mpay";

                  if (resData[i].orderamount.mpay == null) {
                    orderamount_mpay = Number(
                      resData[i].orderamount.overtime_fee
                    );
                  } else {
                    orderamount_mpay = Number(
                      resData[i].orderamount.overtime_fee +
                        resData[i].orderamount.mpay
                    );
                  }

                  if (
                    Number(
                      resData[i].orderamount.credit +
                        resData[i].orderamount.credit_tw
                    ) > 0
                  ) {
                    orderamount_credit =
                      Number(resData[i].orderamount.credit) +
                      Number(resData[i].orderamount.credit_tw);
                  } else {
                    orderamount_credit = 0;
                  }

                  if (resData[i].orderamount.cash > 0) {
                    orderamount_cash = Number(resData[i].orderamount.cash);
                  } else {
                    orderamount_cash = 0;
                  }

                  if (resData[i].orderamount.alipay > 0) {
                    orderamount_alipay = Number(resData[i].orderamount.alipay);
                  } else {
                    orderamount_alipay = 0;
                  }

                  if (resData[i].orderamount.macaupay > 0) {
                    orderamount_macaupass = Number(
                      resData[i].orderamount.macaupay
                    );
                  } else {
                    orderamount_macaupass = 0;
                  }

                  if (resData[i].orderamount.boc > 0) {
                    orderamount_zyPos = Number(resData[i].orderamount.boc);
                  } else {
                    orderamount_zyPos = 0;
                  }

                  if (resData[i].orderamount.icbc > 0) {
                    orderamount_icbc = Number(resData[i].orderamount.icbc);
                  } else {
                    orderamount_icbc = 0;
                  }

                  if (resData[i].orderamount.wechat > 0) {
                    orderamount_wxpay = Number(resData[i].orderamount.wechat);
                  } else {
                    orderamount_wxpay = 0;
                  }
                }

                if (resData[i].orderamount.order_online == 6) {
                  //澳門通
                  order_online = "二次/澳門通";

                  if (resData[i].orderamount.macaupass == null) {
                    orderamount_macaupass = Number(
                      resData[i].orderamount.overtime_fee
                    );
                  } else {
                    orderamount_macaupass = Number(
                      resData[i].orderamount.overtime_fee +
                        resData[i].orderamount.macaupass
                    );
                  }

                  if (
                    Number(
                      resData[i].orderamount.credit +
                        resData[i].orderamount.credit_tw
                    ) > 0
                  ) {
                    orderamount_credit = Number(
                      resData[i].orderamount.credit +
                        resData[i].orderamount.credit_tw
                    );
                  } else {
                    orderamount_credit = 0;
                  }

                  if (resData[i].orderamount.cash > 0) {
                    orderamount_cash = Number(resData[i].orderamount.cash);
                  } else {
                    orderamount_cash = 0;
                  }

                  if (resData[i].orderamount.alipay > 0) {
                    orderamount_alipay = Number(resData[i].orderamount.alipay);
                  } else {
                    orderamount_alipay = 0;
                  }

                  if (resData[i].orderamount.mpay > 0) {
                    orderamount_mpay = Number(resData[i].orderamount.mpay);
                  } else {
                    orderamount_mpay = 0;
                  }

                  if (resData[i].orderamount.boc > 0) {
                    orderamount_zyPos = Number(resData[i].orderamount.boc);
                  } else {
                    orderamount_zyPos = 0;
                  }

                  if (resData[i].orderamount.icbc > 0) {
                    orderamount_icbc = Number(resData[i].orderamount.icbc);
                  } else {
                    orderamount_icbc = 0;
                  }

                  if (resData[i].orderamount.wechat > 0) {
                    orderamount_wxpay = Number(resData[i].orderamount.wechat);
                  } else {
                    orderamount_wxpay = 0;
                  }
                }

                if (resData[i].orderamount.order_online == 7) {
                  //Alipay

                  order_online = "二次/支付寶";

                  if (resData[i].orderamount.alipay == null) {
                    orderamount_alipay = Number(
                      resData[i].orderamount.overtime_fee
                    );
                  } else {
                    orderamount_alipay = Number(
                      resData[i].orderamount.overtime_fee +
                        resData[i].orderamount.alipay
                    );
                  }

                  if (
                    Number(
                      resData[i].orderamount.credit +
                        resData[i].orderamount.credit_tw
                    ) > 0
                  ) {
                    orderamount_credit =
                      Number(resData[i].orderamount.credit) +
                      Number(resData[i].orderamount.credit_tw);
                  } else {
                    orderamount_credit = 0;
                  }

                  if (resData[i].orderamount.cash > 0) {
                    orderamount_cash = Number(resData[i].orderamount.cash);
                  } else {
                    orderamount_cash = 0;
                  }

                  if (resData[i].orderamount.macaupay > 0) {
                    orderamount_macaupass = Number(
                      resData[i].orderamount.macaupay
                    );
                  } else {
                    orderamount_macaupass = 0;
                  }

                  if (resData[i].orderamount.mpay > 0) {
                    orderamount_mpay = Number(resData[i].orderamount.mpay);
                  } else {
                    orderamount_mpay = 0;
                  }

                  if (resData[i].orderamount.boc > 0) {
                    orderamount_zyPos = Number(resData[i].orderamount.boc);
                  } else {
                    orderamount_zyPos = 0;
                  }

                  if (resData[i].orderamount.icbc > 0) {
                    orderamount_icbc = Number(resData[i].orderamount.icbc);
                  } else {
                    orderamount_icbc = 0;
                  }

                  if (resData[i].orderamount.wechat > 0) {
                    orderamount_wxpay = Number(resData[i].orderamount.wechat);
                  } else {
                    orderamount_wxpay = 0;
                  }
                }

                if (resData[i].orderamount.order_online == 8) {
                  //現金

                  order_online = "二次/現金";

                  orderamount_cash = Number(
                    resData[i].orderamount.overtime_fee +
                      resData[i].orderamount.cash
                  );

                  if (
                    Number(
                      resData[i].orderamount.credit +
                        resData[i].orderamount.credit_tw
                    ) > 0
                  ) {
                    orderamount_credit =
                      Number(resData[i].orderamount.credit) +
                      Number(resData[i].orderamount.credit_tw);
                  } else {
                    orderamount_credit = 0;
                  }

                  if (resData[i].orderamount.alipay > 0) {
                    orderamount_alipay = Number(resData[i].orderamount.alipay);
                  } else {
                    orderamount_alipay = 0;
                  }

                  if (resData[i].orderamount.macaupay > 0) {
                    orderamount_macaupass = Number(
                      resData[i].orderamount.macaupay
                    );
                  } else {
                    orderamount_macaupass = 0;
                  }

                  if (resData[i].orderamount.mpay > 0) {
                    orderamount_mpay = Number(resData[i].orderamount.mpay);
                  } else {
                    orderamount_mpay = 0;
                  }

                  if (resData[i].orderamount.boc > 0) {
                    orderamount_zyPos = Number(resData[i].orderamount.boc);
                  } else {
                    orderamount_zyPos = 0;
                  }

                  if (resData[i].orderamount.icbc > 0) {
                    orderamount_icbc = Number(resData[i].orderamount.icbc);
                  } else {
                    orderamount_icbc = 0;
                  }

                  if (resData[i].orderamount.wechat > 0) {
                    orderamount_wxpay = Number(resData[i].orderamount.wechat);
                  } else {
                    orderamount_wxpay = 0;
                  }
                }

                if (
                  resData[i].orderamount.order_online == null ||
                  resData[i].orderamount.order_online == 0
                ) {
                  //NULL
                  order_online = "一次";

                  if (
                    Number(
                      resData[i].orderamount.credit +
                        resData[i].orderamount.credit_tw
                    ) > 0
                  ) {
                    orderamount_credit =
                      Number(resData[i].orderamount.credit) +
                      Number(
                        resData[i].orderamount.credit_tw +
                          resData[i].orderamount.overtime_fee
                      );
                  } else {
                    orderamount_credit = 0;
                  }

                  if (resData[i].orderamount.cash > 0) {
                    orderamount_cash = Number(
                      resData[i].orderamount.cash +
                        resData[i].orderamount.overtime_fee
                    );
                  } else {
                    orderamount_cash = 0;
                  }

                  if (resData[i].orderamount.alipay > 0) {
                    // orderamount_alipay = Number(resData[i].orderamount.alipay + resData[i].orderamount.overtime_fee);
                    orderamount_alipay = Number(resData[i].orderamount.alipay);
                  } else {
                    orderamount_alipay = 0;
                  }

                  if (resData[i].orderamount.macaupay > 0) {
                    orderamount_macaupass = Number(
                      resData[i].orderamount.macaupay
                    );
                  } else {
                    orderamount_macaupass = 0;
                  }

                  if (resData[i].orderamount.mpay > 0) {
                    orderamount_mpay = Number(resData[i].orderamount.mpay);
                  } else {
                    orderamount_mpay = 0;
                  }

                  if (resData[i].orderamount.boc > 0) {
                    orderamount_zyPos = Number(resData[i].orderamount.boc);
                  } else {
                    orderamount_zyPos = 0;
                  }

                  if (resData[i].orderamount.icbc > 0) {
                    orderamount_icbc = Number(resData[i].orderamount.icbc);
                  } else {
                    orderamount_icbc = 0;
                  }

                  if (resData[i].orderamount.wechat > 0) {
                    orderamount_wxpay = Number(resData[i].orderamount.wechat);
                  } else {
                    orderamount_wxpay = 0;
                  }
                }

                tempArr.push({
                  id: resData[i].id,

                  recipient_contacts:
                    resData[i].recipient_contacts +
                    "【" +
                    (resData[i].user?.user_integral + integral_tw) +
                    "】", //客戶名稱【積分】

                  recipient_phone: resData[i].recipient_phone, //客戶電話

                  productName: resData[i]?.detailed?.name, //品名

                  odd_numbers: resData[i].odd_numbers, //出貨單號

                  sack_number: resData[i].sack_number, //袋號

                  receivingName:
                    resData[i].store == null
                      ? "- - -"
                      : resData[i].store.ReceivingName, //取貨櫃點

                  shelves:
                    resData[i].shelves == null
                      ? "- - -"
                      : resData[i].shelves.code, //貨架號

                  status: resData[i].status,

                  pay_status: resData[i].pay_status, //付款状况

                  in_time:
                    resData[i].in_time == null ? "- - -" : resData[i].in_time, //珠海倉入庫

                  out_time:
                    resData[i].out_time == null ? "- - -" : resData[i].out_time, //珠海倉出庫

                  macao_originating_time:
                    resData[i].macao_originating_time == null
                      ? "- - -"
                      : resData[i].macao_originating_time, //澳門倉入庫

                  macao_originating_out_time:
                    resData[i].macao_originating_out_time == null
                      ? "- - -"
                      : resData[i].macao_originating_out_time, //澳門倉出庫

                  arrive_time:
                    resData[i].arrive_time == null
                      ? "- - -"
                      : resData[i].arrive_time, // 未簽收時間

                  pick_time:
                    resData[i].pick_time == null
                      ? "- - -"
                      : resData[i].pick_time, // 簽收時間

                  freight_collect: Number(resData[i].freight_collect), // 代收费和合计

                  surcharge_price: resData[i].orderamount.additional_fee
                    ? resData[i].orderamount.additional_fee
                    : 0, // 附加費

                  amount: Number(resData[i].amount), // 代收費

                  sum: resData[i].orderamount.allamount
                    ? resData[i].orderamount.allamount
                    : 0,

                  outtimepay: resData[i].orderamount.overtime_fee
                    ? resData[i].orderamount.overtime_fee
                    : 0, //超期費

                  activity:
                    resData[i].orderamount.discount == 0
                      ? "無立減"
                      : "-" + resData[i].orderamount.discount, // 立減3元

                  remarks: resData[i].remarks, // 備註

                  additional_fee: orderamount_additional_fee, // 附加費

                  credit: orderamount_credit, //已簽收-積分

                  cash: orderamount_cash, //已簽收-現金

                  alipay: orderamount_alipay, //已簽收-支付寶

                  macaupass: orderamount_macaupass, //已簽收-澳門通

                  mpay: orderamount_mpay, //已簽收-澳門錢包

                  zyPos: orderamount_zyPos, //已簽收-中銀

                  icbc: orderamount_icbc, //已簽收-工銀

                  wxpay: orderamount_wxpay, //已簽收-微信

                  order_type: order_type, //新或舊

                  order_online: order_online,

                  pay_type:
                    resData[i].pay_type == 0
                      ? "未在APP內付款"
                      : "已在APP內付款", //付款状况

                  admininfo_realname:
                    resData[i].admininfo == null
                      ? "- - -"
                      : resData[i].admininfo.realname,

                  count: resData[i].count,

                  weight: resData[i].weight,

                  volume_weight: resData[i].volume_weight,

                  arrive_type: resData[i].arrive_type,
                });
              } else {
                order_type = "舊";

                tempArr.push({
                  id: resData[i].id,

                  recipient_contacts:
                    resData[i].recipient_contacts +
                    "【" +
                    (resData[i].user?.user_integral + integral_tw) +
                    "】", //客戶名稱【積分】

                  recipient_phone: resData[i].recipient_phone, //客戶電話

                  productName: resData[i].detailed.name, //品名

                  odd_numbers: resData[i].odd_numbers, //出貨單號

                  sack_number: resData[i].sack_number, //袋號

                  receivingName:
                    resData[i].store == null
                      ? "- - -"
                      : resData[i].store.ReceivingName, //取貨櫃點

                  shelves:
                    resData[i].shelves == null
                      ? "- - -"
                      : resData[i].shelves.code, //貨架號

                  status: resData[i].status,

                  pay_status: resData[i].pay_status, //付款状况

                  in_time:
                    resData[i].in_time == null ? "- - -" : resData[i].in_time, //珠海倉入庫

                  out_time:
                    resData[i].out_time == null ? "- - -" : resData[i].out_time, //珠海倉出庫

                  macao_originating_time:
                    resData[i].macao_originating_time == null
                      ? "- - -"
                      : resData[i].macao_originating_time, //澳門倉入庫

                  macao_originating_out_time:
                    resData[i].macao_originating_out_time == null
                      ? "- - -"
                      : resData[i].macao_originating_out_time, //澳門倉出庫

                  arrive_time:
                    resData[i].arrive_time == null
                      ? "- - -"
                      : resData[i].arrive_time, // 未簽收時間

                  pick_time:
                    resData[i].pick_time == null
                      ? "- - -"
                      : resData[i].pick_time, // 簽收時間

                  freight_collect: Number(resData[i].freight_collect), // 代收费和合计

                  surcharge_price: Number(resData[i].surcharge_price), // 附加费

                  amount: Number(resData[i].amount), // 代收費

                  count: resData[i].count,

                  weight: resData[i].weight,

                  volume_weight: resData[i].volume_weight,

                  arrive_type: resData[i].arrive_type,

                  sum:
                    Number(resData[i].freight_collect) +
                    Number(resData[i].surcharge_price) +
                    Number(resData[i].amount) +
                    Number(resData[i].outtimepay), //合計費用

                  outtimepay: resData[i].outtimepay ? resData[i].outtimepay : 0, //超期費

                  activity:
                    resData[i].store == null
                      ? "0"
                      : "-" + resData[i].store.offline_activity, // 立減3元

                  remarks: resData[i].remarks, // 備註

                  credit: resData[i].credit ? resData[i].credit : 0,

                  cash: resData[i].cash ? resData[i].cash : 0,

                  alipay: resData[i].alipay ? resData[i].alipay : 0,

                  macaupass: resData[i].macaupass ? resData[i].macaupass : 0,

                  mpay: resData[i].mpay ? resData[i].mpay : 0,

                  zyPos: resData[i].zyPos ? resData[i].zyPos : 0,

                  icbc: resData[i].icbc ? resData[i].icbc : 0,

                  wxpay: resData[i].wxpay ? resData[i].wxpay : 0,

                  order_type: order_type,

                  order_online: "舊",

                  admininfo_realname:
                    resData[i].admininfo == null
                      ? "- - -"
                      : resData[i].admininfo.realname,
                });
              }
            }

            this.totalCount = res.data.count;
            this.table.data = tempArr;
          } else {
            this.showTipInfo(res.msg);
          }
        })
        .catch((err) => {
          this.isSubmiting = false;
        });
    },
    handleSearch() {
      this.pageIndex = 1;
      this.getList();
    },
    handlePageSizeChange(value) {
      this.pageIndex = 1;
      this.getList();
    },
    handlePageInput() {
      let value = ("" + this.pageInput).replace(/\D/g, "");
      let pageCount = Math.ceil(this.totalCount / this.curPageSize);
      if (value > pageCount) {
        value = pageCount;
      }
      this.pageInput = value;
    },
    handlePageEnter() {
      if (this.pageInput == "" || this.pageInput == this.pageIndex) return;
      if (this.pageInput == 0) {
        this.pageInput = 1;
      }
      this.pageInput = parseInt(this.pageInput);
      this.pageIndex = this.pageInput;
      this.getList();
    },
    handlePageChange(value) {
      this.pageIndex = value;
      this.getList();
    },
  },
};
</script>

<style lang="scss" scoped>
@import "signOrderManage.scss";
</style>
<style>
.ivu-table td.demo-table-info-column {
  background-color: #ffebde;
  color: #000;
}

.ivu-table td.demo-table-info-cell-name {
  background-color: #d6e7ff;
  color: #000;
}
</style>
